<nav class="navbar">
  <div
    class="navbar-content"
    [class.expanded]="isExpanded"
    style="
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    "
  >
    <div style="display: flex; align-items: center">
      <a routerLink="/">
        <img
          src="assets/images/logo-sura-blanco.svg"
          alt="Logo Sura"
          class="navbar-logo"
          style="cursor: pointer"
        />
      </a>
      <button
        class="navbar-title"
        (click)="openInfoModal()"
        type="button"
        style="
          cursor: pointer;
          background: none;
          border: none;
          color: inherit;
          font: inherit;
        "
        aria-label="Open information modal"
      >
        Biociencias
      </button>
    </div>
    @if (showAvatarSection) {
      <div style="position: relative; display: flex; align-items: center">
        <app-bell-notification></app-bell-notification>
        <app-avatar
          id="topbar-profile-menu-button"
          [name]="user.fullName"
          [label]="
            'Última conexión: ' +
            (user.lastAccess && (user.lastAccess | date: 'dd/MM/yyyy'))
          "
          [border]="true"
          [icon]="'pi-chevron-down'"
          [iconSecondary]="'pi-chevron-up'"
          (clicked)="toggleUserMenu()"
        ></app-avatar>
        <ul
          class="fadeInDown menu"
          [class.usermenu-active]="userMenuActive"
          id="topbar-usermenu"
          style="
            position: absolute;
            right: 0;
            top: 3.5rem;
            min-width: 180px;
            z-index: 1000;
          "
        >
          <li>
            <button
              id="logout"
              (click)="onLogout()"
              type="button"
              aria-label="Logout"
            >
              <em class="pi pi-power-off mr-1"></em>
              <span class="topbar-item-name">Cerrar Sesión</span>
            </button>
          </li>
        </ul>
      </div>
    }
  </div>
</nav>
@if (showInfoModal) {
  <app-generic-modal
    [imageSrc]="modalImage"
    [title]="modalTitle"
    [boldText]="modalBold"
    [description]="modalDesc"
    [noText]="noText"
    [yesText]="yesText"
    (close)="closeInfoModal()"
    (confirm)="onModalConfirm()"
  ></app-generic-modal>
}
